import React from 'react'

export function PhoneIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#2AAD87"
        fillRule="evenodd"
        d="M6.085 4.5c-.806 0-1.309.722-1.079 1.404.826 2.447 2.365 6.129 4.66 8.424s5.976 3.833 8.424 4.66c.682.23 1.404-.273 1.404-1.08v-2.485a.245.245 0 00-.125-.214l-2.165-1.203a.245.245 0 00-.229-.005l-2.308 1.154a.735.735 0 01-.467.065l.139-.722-.139.722h-.002l-.003-.001-.007-.002-.022-.004a4.418 4.418 0 01-.32-.082 7.27 7.27 0 01-.828-.296 7.367 7.367 0 01-2.313-1.546 7.4 7.4 0 01-1.549-2.316 7.328 7.328 0 01-.364-1.076 3.517 3.517 0 01-.016-.073l-.005-.022-.001-.008-.001-.002V9.79l.72-.142-.72.142a.738.738 0 01.064-.47l1.154-2.309a.245.245 0 00-.005-.228L8.784 4.625A.245.245 0 008.57 4.5H6.085zm4.184 5.234c.047.16.123.39.239.662.233.545.62 1.238 1.236 1.854l-.52.52m.52-.52a5.898 5.898 0 001.85 1.233c.27.115.5.19.659.236l2.065-1.032a1.714 1.714 0 011.6.035l2.165 1.203c.544.303.88.876.88 1.498v2.485c0 1.725-1.628 3.05-3.343 2.471-2.478-.836-6.442-2.461-8.993-5.012-2.551-2.551-4.177-6.515-5.013-8.993-.579-1.716.746-3.344 2.471-3.344H8.57c.622 0 1.196.338 1.498.882l1.199 2.158c.274.495.287 1.093.034 1.6L10.27 9.733"
        clipRule="evenodd"
      />
    </svg>
  )
}
